export enum MarketType {
  BMV = 0,
  SIC = 2,
  USA = 99,
}

export enum MarketTypeString {
  BMV = 'BMV',
  SIC = 'SIC',
  USA = 'USA',
}

export enum MarketName {
  BMV = 'marketBMV',
  SIC = 'marketSIC',
  USA = 'marketUSA',
}

export const Markets = {
  [MarketType.BMV]: {
    type: MarketType.BMV,
    typeString: MarketTypeString.BMV,
    name: MarketName.BMV,
  },
  [MarketType.SIC]: {
    type: MarketType.SIC,
    typeString: MarketTypeString.SIC,
    name: MarketName.SIC,
  },
  [MarketType.USA]: {
    type: MarketType.USA,
    typeString: MarketTypeString.USA,
    name: MarketName.USA,
  },
};

export function getMarketName(type: MarketType): MarketName {
  return Markets[type].name;
}

export function getMarketTypeString(type: MarketType): MarketTypeString {
  return Markets[type].typeString;
}
